<template>
  <div class="content">
    <div class="pr cons4">
      <div class="header">
        <div class="header-menu uni-flex align-items">
          <div class="mr10">
            <img src="../static/images/logo1.png" alt="">
          </div>
          <div class="wpd30">
            <img src="../static/images/logo2.png" alt="">
          </div>
          <div class="uni-flex-item uni-flex head-nav">
            <div class="f18 fw cf" @click="scrollTo(0)">豆芽部落</div>
            <div class="f18 fw cf" @click="scrollTo(1)">图游图播</div>
            <div class="f18 fw cf" @click="scrollTo(2)">云图库</div>
            <div class="f18 fw cf" @click="scrollTo(3)">合作伙伴</div>
          </div>
        </div>
      </div>      
      <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide pr">
              <img class="banner-img" src="../static/images/banner1.png">
            </div>
            <div class="swiper-slide pr">
              <img class="banner-img" src="../static/images/banner2.png">
            </div>
            <div class="swiper-slide pr">
              <img class="banner-img" src="../static/images/banner3.png">
            </div>
            <div class="swiper-slide pr">
              <img class="banner-img" src="../static/images/banner4.png">
            </div>
            <div class="swiper-slide pr">
              <img class="banner-img" src="../static/images/banner5.png">
            </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="con-img">
      <img class="about-img" src="../static/images/img3.png">
      <div class="tc">
        <div class="c6 f22 hpd30">关于思考豆</div>
        <div class="f14 c7">思考豆科技，数字文旅图片数据应用研发运营服务商，<br>专注于文旅领域图片数字化产生和应用，<br>服务旅行Plog原创作者的创作需要、作品版权保护、交易和应用，<br>致力文旅休闲度假产品研发服务营销推广一体化研究与应用，<br>推动文旅产业经济发展。</div>
      </div>
    </div>
    <div class="center-box">
      <div class="uni-flex justify-c">
        <div class="wpd30">
          <img src="../static/images/qrcode1.png">
          <div class="tc hpd10 c3 f12">微信Wechat</div>
        </div>
        <div class="wpd30 hpd20"></div>
        <div class="wpd30">
          <img src="../static/images/qrcode2.png">
          <div class="tc hpd10 c3 f12">微博Weibo</div>
        </div>
      </div>
      <div class="wpd30 hpd30"></div>
      <div class="wpd30 hpd30"></div>
    </div>
    <div class="app-box cons0">
      <div class="center-box uni-flex">
        <div class="hpd10">
          <div class="tc fw c6 f18 hpd40">豆芽部落APP</div>
          <div class="tc c7 f16">记录美妙旅途</div>
          <div class="wpd30 hpd30"></div>
          <div class="tc f14 c7 mb20" style="line-height: 26px">旅行plog服务商，<br>帮助旅行Plog原创作者，<br>推动旅行Plog发展，<br>帮助更多爱旅游爱摄影爱创作的达人成长成就。</div>
          <div class="hpd15 uni-flex justify-c download-btn pr">
            <img class="phone-img" src="../static/images/btn1.png" alt="">
           <img class="download-img" src="../static/images/download_android.png">
          </div>
          <div class="hpd15 uni-flex justify-c download-btn pr">
            <img class="phone-img" src="../static/images/btn2.png" alt="">
            <img class="download-img" src="../static/images/download_ios.png">
          </div>
        </div>
        <div class="uni-flex-item uni-flex download-btn pr" style="justify-content: flex-end;">
          <img class="phone-img" src="../static/images/img2.png" alt="">
        </div>
      </div>
    </div>
    <div class="app-box cons1" style="background:#EFE9DF; padding: 67px 0 96px">
      <div class="center-box uni-flex">
        <div class="uni-flex-item uni-flex">
          <img class="phone-img" src="../static/images/img1.png" alt="">
        </div>
        <div style="padding-top: 200px">
          <div class="tc fw c6 f18">图游图播</div>
          <div class="wpd30 hpd30"></div>
          <div class="tc f14 c7 mb20" style="line-height: 26px">旅行Plog运营平台，<br>帮助文旅局、景区和文旅企业服务文旅市场需求，<br>更好地帮助产品与市场需要进行互动，<br>提升服务能力，<br>促进文旅事业发展和经济增长。</div>
        </div>
      </div>
    </div>
   <div class="app-box cons2" style="padding:10px 0; background:#ffffff;">
      <div class="center-box uni-flex">
        <div style="padding-top:250px">
          <div class="tc fw c6 f18">云图库</div>
          <div class="tc c7 f16 hpd30">（文旅数字图片数据库）</div>
          <div class="tc f14 c7 mb20" style="line-height: 26px">帮助文旅局和文旅图片需求单位建设云图库，<br>解决图片应用的安全问题，<br>开发图片市场价值，<br>促进文旅事业发展。</div>
        </div>
        <div class="uni-flex-item uni-flex" style="justify-content: flex-end;">
          <img class="phone-img" src="../static/images/img4.png" alt="">
        </div>
      </div>
    </div>
    <div class="center-box cons3" style="padding:120px 0">
      <div class="uni-flex justify-c mb20">
        <img class="phone-img" src="../static/images/ico3.png" alt="">
      </div>
      <div class="tc fw f18 c6 hpd40 mb10">合作伙伴</div>
      <div class="tc f14 c7" style="line-height: 26px">拥有丰富的行业案例，<br>目前服务的包括湖北省文化和旅游厅、浙江旅游信息中心、台州市文旅局、北京密云文旅局、上海金山文旅局在内全国30多家文旅局，<br>与文化和旅游部信息中心也有合作关系，了解文旅对云图库的应用需求。</div>
    </div>
    <div class="footer-box">
      <div class="center-box uni-flex hpd40 align-items">
        <div class="uni-flex-item">
          <div class="uni-flex hpd10">
            <div class="wpd10">
              <img src="../static/images/qrcode1.png">
              <div class="tc hpd10 cf f12">微信Wechat</div>
            </div>
            <div class="wpd10 hpd20"></div>
            <div class="wpd40">
              <img src="../static/images/qrcode2.png">
              <div class="tc hpd10 cf f12">微博Weibo</div>
            </div>
          </div>
          <div class="f12 cf hpd20">微博微信搜索或扫码关注豆芽部落，第一时间获取豆芽部落相关资讯。<br>如果你有任何疑问或建议，可以在微博或者微信私信我们，我们会尽快处理。</div>
        </div>
        <div class="cf tr">
          <div class="cf f12">思考豆（杭州）科技有限公司</div>
          <div class="cf f12 hpd5">地址：杭州毛家桥路中天MCC2-401-3</div>
          <div class="cf f12">客服热线：0571-81061939</div>
          <div class="cf f12 hpd5">市场合作：15824140565 Sane</div>
          <div class="cf f12">商务邮箱：sane@douya.wang</div>
          <div class="cf f12 hpd5" @click="handleLink">浙ICP备20020636号-1</div>
        </div>
      </div>
    </div>
    <div class="arr-top" @click="scrollTo(4)">
      <img src="../static/images/arrow.png">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Swiper from 'swiper'
import "swiper/css/swiper.css";
export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  mounted() {
    new Swiper ('.swiper-container', {
      loop: true,
      speed: 3000,
      effect : 'fade',
      autoplay: {
        delay: 7000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
      }
    })   
  },
  methods: {
		handleLink() {
			window.open('https://beian.miit.gov.cn')
		},
    scrollTo(index) {
      // 获取目标的 offsetTop
      const targetOffsetTop = document.querySelector('.cons'+index).offsetTop
      // 获取当前 offsetTop
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp()
      } else {
        // 往下滑
        smoothDown()
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          requestAnimationFrame(smoothDown)
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          requestAnimationFrame(smoothUp)
        }
      }
    }
  }
}
</script>
<style>
.footer-box{
  background: #383734;
  width: 100%;
  
}
.content{
  min-width: 1200px;
}
.center-box{
  width: 1000px;
  margin: 0 auto;
}
.swiper-container {
  width: 100%;
  min-width: 1000px;
  height: 1047px;
}
.swiper-slide{
  overflow: hidden;
}
.banner-img{
  width: 1923px;
  height: 1047px;
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -961px;
}
.header{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
}
.header-menu{
  width: 100%;
  max-width: 1400px;
  min-width: 1200px;
  margin: 0 auto;
  height: 125px;
}
.head-nav{
  justify-content: flex-end;
}
.head-nav .f18{
  margin-left: 85px;
}
.swiper-pagination-bullet{
  width: 15px;
  height: 6px;
  border-radius: 2px;
  opacity: 1;
  background-color: #ffffff;
}
.swiper-pagination-bullet-active{
  background-color: #6C6D6C;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet{
  margin: 0 12px;
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
  bottom: 70px;
}
.con-img{
  width: 100%;
  height: 334px;
  margin-bottom: 22px;
  position: relative;
  overflow: hidden;
}
.about-img{
  width: 1903px;
  height: 334px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -951px;
}
.app-box{
  width: 100%;
  background: #E7E7E7;
  padding-top: 100px;
  box-shadow:0px -20px 20px -20px rgba(0, 0, 0, .4) inset;
}
.phone-img{
  display: block;
}
.download-btn:hover .download-img{
  display: block;
}
.download-img{
  position: absolute;
  top: 90px;
  right: 0;
  z-index: 99;
  display: none;
  width: 180px;
}
.arr-top{
  position: fixed;
  bottom: 20%;
  right: 100px;
}
</style>